<template>
  <div class="heroes-pick" :class="classes">
    <HeroesPickReset v-if="isLiveMatch" />
    <HeroesPickStatus v-if="showStatus" />
    <HeroesPickResult
      v-if="heroes && showResult"
      :pick="match.pick_ban_info.selected_hero_id"
    />
    <div v-if="heroes" class="heroes-pick__body">
      <div class="heroes-pick__side-wrapper">
        <HeroesSidePicks
          class="heroes-pick__bans"
          left
          ban
          :number="3"
          :picks="bans_1"
        />
        <HeroesSidePicks left pick :number="1" :picks="picks_1" />
      </div>
      <HeroesList v-if="showList" class="heroes-pick__list" />
      <div class="heroes-pick__side-wrapper">
        <HeroesSidePicks
          class="heroes-pick__bans"
          right
          ban
          :number="3"
          :picks="bans_2"
        />
        <HeroesSidePicks right pick :number="1" :picks="picks_2" />
      </div>
    </div>
  </div>
</template>

<script>
import HeroesList from "./HeroesList";
import HeroesSidePicks from "./HeroesSidePicks";
import HeroesPickReset from "./HeroesPickReset";
import HeroesPickStatus from "./HeroesPickStatus";
import HeroesPickResult from "./HeroesPickResult";
import { ActionType, PicksStatus } from "./types";
import { mapState, mapGetters, mapActions } from "vuex";
import showAlert from "@/services/common/showAlert";

export default {
  name: "HeroesPick",

  components: {
    HeroesList,
    HeroesSidePicks,
    HeroesPickStatus,
    HeroesPickReset,
    HeroesPickResult
  },

  props: {
    match: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState("dictionaries", {
      heroes: ({ dictionaries }) => dictionaries.heroes
    }),
    ...mapGetters("tournaments", ["isParticipant"]),
    isLiveMatch() {
      return this.match.status === 3;
    },
    showStatus() {
      return this.match.pick_ban_info.status === PicksStatus.Inprogress;
    },
    showResult() {
      return (
        this.match.pick_ban_info.status === PicksStatus.Finished &&
        !!this.match.pick_ban_info.selected_hero_id
      );
    },
    showList() {
      return (
        this.isParticipant &&
        this.match.pick_ban_info.status === PicksStatus.Inprogress
      );
    },
    classes() {
      return {
        "heroes-pick_picks-only": !this.showList
      };
    },
    bans() {
      return this.match.pick_ban_history.filter(
        item =>
          item.action === ActionType.Ban || item.action === ActionType.BanRandom
      );
    },
    picks() {
      return this.match.pick_ban_history.filter(
        item =>
          item.action === ActionType.Pick ||
          item.action === ActionType.PickRandom
      );
    },
    bans_1() {
      return this.bans.filter(item => item.player_id === this.match.player1.id);
    },
    bans_2() {
      return this.bans.filter(item => item.player_id === this.match.player2.id);
    },
    picks_1() {
      return this.picks.filter(
        item => item.player_id === this.match.player1.id
      );
    },
    picks_2() {
      return this.picks.filter(
        item => item.player_id === this.match.player2.id
      );
    }
  },

  created() {
    if (!this.heroes) {
      this.getDictionary("heroes");
    }
  },

  methods: {
    ...mapActions("dictionaries", ["getDictionary"])
  },

  sockets: {
    reset_pick_ban({ match_id }) {
      if (this.match.id !== +match_id) return;
      showAlert("Пики были перезапущены.");
    }
  }
};
</script>

<style lang="scss">
$p: ".heroes-pick";

.heroes-pick {
  padding: 8px;
  margin-bottom: 40px;

  &__body {
    display: flex;
  }

  &__side-wrapper {
    width: 110px;
    flex-shrink: 0;
  }

  &__bans {
    margin-bottom: 20px;
  }

  &__list {
    width: 100%;
    max-width: 790px;
    margin: 0 auto;
  }

  @include breakpoint("md-and-down") {
    &__side-wrapper {
      width: 100%;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
    }
    &__body {
      flex-direction: column;
    }
    &__bans {
      margin-bottom: 0;
      margin-right: 20px;
    }
    &__list {
      order: 2;
    }
  }

  @include breakpoint("xs-only") {
    &__side-wrapper {
      flex-direction: column;
      align-items: center;
    }
    &__bans {
      margin-bottom: 20px;
      margin-right: 0;
    }
  }

  &_picks-only {
    margin-bottom: 0;
    #{$p}__body {
      justify-content: space-between;
      margin-bottom: -356px;
    }
    @include breakpoint("md-and-down") {
      margin-bottom: 40px;
      #{$p}__body {
        justify-content: center;
        margin-bottom: 0;
      }
    }
  }
}
</style>
